import React, { useState, useEffect } from "react";
import "components/Layout/style.css";
import FermeImg from "assets/img/ferme.svg";
import Grid from "@mui/material/Grid";
import { useStore } from "_Store";
import WelcomeLayout from "pages/Shared/WelcomeLayout";
import Accordion, { AccordionType2 } from "components/Ui/Accordion";
import { useContext } from "react";
import { Store } from "components/Ui";

const PhytoChoose = (props) => {
  const { state } = useStore();
  const [selectedValue, setSelectedValue] = React.useState(
    state?.["tableDataResponse"]?.["phyto"] || ""
  );
  const [errors, setErrors] = React.useState("");

  const {
    state: {
      activeFarm,
      activeCampaign,
      tableDataResponse
    }
  } = useContext(Store);

  const {
    setUtils
  } = useStore(Store);

  const farmList = [activeFarm];
  const farm = activeFarm;
  const [expanded, setExpanded] = React.useState(farm.id);
  const [commodities, setCommodities] = useState([]);
  const [phytoDatas, setPhytoData] = React.useState([]);
  const validation = () => {
    if (selectedValue) {
      return true;
    } else {
      setErrors("Une option radio est requise");
      return false;
    }
  };
  const handleSubmit = (save) => {
    const res = validation();
    if (res) {
        props.onSubmit({ phytoProductId: selectedValue }, save);
    }
  };

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const handleSelect = (event) => {
    setSelectedValue(Number(event.target.value));
    setErrors("");
  };

  function getPhytoData(){
    let products = activeCampaign.phytoProductRequirement,
        data =[];
    if(products && products.length > 0){
       for(const product of products){
         let phyto = product;
         data=[...data,{id: phyto.id,name: phyto.type}];
       }
     }
     setPhytoData(data)
   }

  useEffect(() => {
    getPhytoData();
  }, []);

  useEffect(() => {
    setCommodities(phytoDatas)
  }, [phytoDatas]);

  return (
    <div>
      <Grid className="stepFormfields">
        <WelcomeLayout
          title={"Choix d'un produit phyto sanitaire"}
          containImg={FermeImg}
          content={"Fiche de Stock"}
          handleSubmit={handleSubmit}
          task={"Chaque opération de stockage sera associée à un produit phyto sanitaire. Veillez donc à choisir la culture sur laquelle l'opération de stockage a été réaliser."}
          buttonLabel={"Continuer"}
          backToStartBtn={{
            label: 'Précédent',
            onClick: () => {
              props.onBack();
            }
          }}
        >
          <div>
              <div className="questionPage">
                 <Accordion
                    expanded={expanded === farm.id}
                    title={farm.farmName}
                    data={farm}
                    errors={errors}
                    subTitle={"Non déterminée"}
                    label={
                      "Veuillez choisir une culture"
                    }
                    options={commodities}
                    handleChange={handleChange}
                    optionSelection={handleSelect}
                    value={selectedValue}
                    isFarm={true}
                    radioButtonClass={"accordionRadio"}
                  />
                {errors?.length > 1 && <p className="errorText">{errors}</p>}
              </div>
          </div>

        </WelcomeLayout>
      </Grid>
    </div>
  );
};

export default PhytoChoose;
